import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "refreshFilled"
const RefreshFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M9.35 3.203C11.533 2.545 13.885 2.723 15.945 3.703S19.63 6.395 20.496 8.506L18.764 9.218C18.073 7.538 16.781 6.177 15.141 5.397S11.63 4.474 9.891 4.998C8.15 5.522 6.67 6.675 5.734 8.231S4.474 11.636 4.826 13.417 6.18 16.787 7.638 17.87C9.096 18.953 10.905 19.455 12.712 19.278S16.197 18.258 17.417 16.912C18.637 15.567 19.312 13.816 19.312 12H21.188C21.188 14.282 20.339 16.482 18.807 18.172 17.273 19.862 15.166 20.922 12.895 21.144S8.351 20.735 6.52 19.374 3.43 16.02 2.987 13.781 2.95 9.22 4.127 7.264 7.165 3.861 9.35 3.203" />
          <path d="M21.188 3.75V9.938H15V8.063H19.313V3.75z" />
        </svg>
      }
    </span>
  )
}
export default RefreshFilledIcon
